export default "__VITE_ASSET__CrxVXQoH__"